import { useEffect, useState } from 'react';

/**
 * Detecta si la app está corriendo como PWA instalada (modo standalone).
 * Chrome/Android: display-mode standalone.
 * iOS Safari: navigator.standalone === true.
 */
export default function usePWAStandalone() {
    const [isStandalone, setIsStandalone] = useState(() => {
        if (typeof window === 'undefined') return false;
        return (
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true
        );
    });

    useEffect(() => {
        const mq = window.matchMedia('(display-mode: standalone)');
        const onChange = () => setIsStandalone(mq.matches || window.navigator.standalone === true);
        mq.addEventListener?.('change', onChange);
        return () => mq.removeEventListener?.('change', onChange);
    }, []);

    return isStandalone;
}

export function detectPlatform() {
    if (typeof navigator === 'undefined') return 'unknown';
    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (isIOS) return 'ios';
    if (/android/.test(ua)) return 'android';
    return 'desktop';
}
